module.exports = __webpack_public_path__ + "img/patient-info-edit.eebcc3d1.svg";